
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import MainLayout from "../layouts/main";
import useTranslation from "next-translate/useTranslation";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import Banner from "../components/pages/home/Banner";
import Progress from "../components/common/Progress";
import Attributes from "../components/pages/home/Attributes";
import Hardware from "../components/pages/home/Hardware";
import PoweredBy from "../components/common/PoweredBy";
import Community from "../components/pages/home/Community";
import Why from "../components/pages/home/Why";
import Media from "../components/common/Media";
import ReadyToStart from "../components/common/ReadyToStart";
import TopLine from "../components/common/TopLine";
export default function Coin({ title, description, canonical }) {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const organizationSchemaData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Coldware Innovations",
        "url": "https://coldware.io",
        "about": "A next-gen blockchain for DeFi, AI, & tokenization. Scalable, fast, & built for real-world adoption.",
        "image": "https://coldware.io/img/main_logo.svg",
        "mainEntity": {
            "@type": "Product",
            "name": "Coldware Innovations",
            "image": "https://coldware.io/img/main_logo.svg",
            "description": "A next-gen blockchain for DeFi, AI, & tokenization. Scalable, fast, & built for real-world adoption.",
            "brand": {
                "@type": "Organization",
                "name": "Coldware Innovations",
                "logo": "https://coldware.io/img/main_logo.svg",
                "contactPoint": {
                    "@type": "ContactPoint",
                    "email": "info@coldware.io",
                    "contactType": "Customer Service"
                },
                "sameAs": [
                    "https://t.me/coldwarenetwork",
                    "https://t.me/coldwarenetwork"
                ]
            }
        }
    };
    return (<MainLayout title={seo.home.title} description={seo.home.description} keywords={seo.home.keywords} page={'index'} canonical={''} organizationSchemaData={organizationSchemaData}>
            <Header t={t}/>
            <main className='main'>
                <Banner t={t}/>
                <div className="progress_index">
                    <Progress t={t}/>
                </div>
                <Attributes t={t}/>
                <Hardware t={t}/>
                <PoweredBy t={t}/>
                <Why t={t}/>
                <Community t={t}/>
                <Media t={t}/>
                <ReadyToStart t={t}/>
            </main>
            <Footer t={t}/>
        </MainLayout>);
}

    async function __Next_Translate__getStaticProps__19763357eca__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19763357eca__ as getStaticProps }
  